<script setup>
import { defineProps } from 'vue';
import axios from 'axios'

const props = defineProps(
    ['id', 'url', 'title']
)

const groupId = props.id;
const siteUrl = props.url;
const siteTitle = props.title;
var loggingFlag = false;

const externalReserveLogging = async (id, url) => {
    try {
        if(!loggingFlag){
            loggingFlag = true;
            const params = new URLSearchParams();
            params.append('group_id', id);
            params.append( 'url', url);
            axios.get('/api/logging-external-reserve', {
                params
            }).then(response => {
                if(response.status == 200){
                    if(!window.open(url, '_blank')){
                        location.href = url;
                    }
                }
            });
        }
    } catch (error) {}
}
</script>

<template>
    <a id="reserve_link" href="javascript:void(0)" @click="externalReserveLogging(groupId, siteUrl)">
        <span v-if="siteTitle">{{siteTitle}}</span>
        <span v-else>Web予約はこちら></span>
    </a>
</template>
